module.exports = __webpack_public_path__ + "files/367721d2ee1cec937e7cdeafb65fd7ab.png";